import React from 'react';
import { Box } from '@mentimeter/ragnar-ui/box';
import type { TextResponse } from '@core-api/presentation/types/response';
import type { InteractiveCanvasComponents } from '@mentimeter/question-modules-types';
import { ResponsesView } from './responses-view/ResponsesView';

const previewData: TextResponse[] = [
  {
    responseText: 'All responses to your question will be shown here',
    id: '0',
    voteCount: 0,
    participant: null,
  },
  {
    responseText: 'Each response can be up to 200 characters long',
    id: '1',
    voteCount: 0,
    participant: null,
  },
  {
    responseText: 'Turn on voting to let participants vote for their favorites',
    id: '2',
    voteCount: 0,
    participant: null,
  },
];

interface EditorEmptyStateProps {
  numberOfColumns: number;
  CanvasVisualizationArea: InteractiveCanvasComponents['CanvasVisualizationArea'];
}

export const EditorEmptyState = ({
  numberOfColumns,
  CanvasVisualizationArea,
}: EditorEmptyStateProps) => {
  return (
    <Box width="100%" height="100%">
      <ResponsesView
        responses={previewData}
        numberOfColumns={numberOfColumns}
        style={{ opacity: 0.5 }}
        CanvasVisualizationArea={CanvasVisualizationArea}
        shouldHideResults={false}
        shouldShowUpvotes={false}
        onOpenOneByOneView={() => {}}
      />
    </Box>
  );
};
